import { gql } from '@apollo/client';

export const LIST_AD_STATUS_TYPES = gql`
  query List {
    listAdStatusType {
      list {
        id
        type
      }
    }
  }
`;
